<template>
  <!-- <div v-if="tagDisplay"> -->
    <!-- <router-view /> -->
    <!-- <div class="loading-container">
      <el-icon class="is-loading"><Loading /></el-icon>
      <span>Config Loading...</span>
    </div>      -->
  <!-- </div>
  <div v-else> -->
    <top-nav :metro="metroName" :metroLogo="metroLogoUrl" />
    <router-view v-slot="{ Component }">
      <transition>
        <keep-alive exclude="DetailView">
          <component :is="Component" />
        </keep-alive>
      </transition>
    </router-view>
    <bottom-claim :realtor="agentName.en" :broker="brokerName" :brokerLogo="brokerLogoUrl" />
  <!-- </div> -->
</template>


<script>
// import { Config } from '../public/conf/config'
import { Loading } from '@element-plus/icons-vue'
import { remoteJS } from '@/utils/remoteJS.js'
import { getMetroList } from '@/utils/api'
import TopNav from '@/components/TopNav'
import BottomClaim from '@/components/BottomClaim'
export default {
  components: { TopNav, BottomClaim, Loading },
  data() {
    return {
      tagDisplay: false,
      metroLogoUrl: '',
      metroName: '',
      metroPosition: null,
      brokerLogoUrl: '',
      brokerName: '',
      agentName: '',
    }
  },
  created() {
    // 设置CSS变量的值
    document.documentElement.style.setProperty('--width', window.innerWidth + 'px');
    document.documentElement.style.setProperty('--height', window.innerHeight + 'px');

    let metropolitan = 'vancouver';
    if (process.env.NODE_ENV == 'production') {
      const host = window.location.host;
      metropolitan = host.replace('.homapp.com', '');
    }

    // 加载远程JS
    this.loadConfig(metropolitan);
    // remoteJS(metropolitan).then(() => {
    //   const Config = Configs();
    //   this.metroLogoUrl = Config.MetroLogo;
    //   this.metroName = Config.MetroName;
    //   this.metroPosition = Config.MetroPosition;
    //   this.brokerLogoUrl = Config.BrokerLogo;
    //   this.brokerName = Config.BrokerName;
    //   this.agentName = Config.AgentName;

    //   this.$store.commit('changeMetroPosition', this.metroPosition);
    //   this.$store.commit('changeMetroName', this.metroName);

    //   getMetroList(Config.MetroName).then(res => {
    //     this.$store.commit('changeMetroCity', res.data);
    //   }).catch(err => {
    //     console.log('Not get metro city');
    //   })
    //   this.isLoaded = true;
    // }).catch(err => {
    //   console.error('Failed to load remoteJS:', err);
    //   // 可以添加错误处理逻辑
    // })
  },
  mounted() {
    // const urlname = window.location.href;
    // const regex = /^.*\.homapp\.com/;
    // this.tagDisplay = regex.test(urlname);
    // if (this.tagDisplay) return;

    // User cookie for visited
    window.onload = function () {
      if (localStorage.getItem('hasVisitedHOMAPP') === null) {
        alert('If you click OK, you accept the Terms of Use Agreement. You can review the Agreement at any time on the bottom of the page.');
        localStorage.setItem('hasVisitedHOMAPP', "true");
        window.location.reload();
      }
    };
  },
  methods: {
    async loadConfig(metropolitan) {
      try {
        await remoteJS(metropolitan);
        const Config = Configs();
        this.metroLogoUrl = Config.MetroLogo;
        this.metroName = Config.MetroName;
        this.metroPosition = Config.MetroPosition;
        this.brokerLogoUrl = Config.BrokerLogo;
        this.brokerName = Config.BrokerName;
        this.agentName = Config.AgentName;

        this.$store.commit('changeMetroPosition', this.metroPosition);
        this.$store.commit('changeMetroName', this.metroName);

        getMetroList(Config.MetroName).then(res => {
          this.$store.commit('changeMetroCity', res.data);
        }).catch(err => {
          console.log('Not get metro city');
        })
        this.tagDisplay = true;
      } catch (err) {
        console.error('Failed to load remoteJS:', err);
        // 可以添加错误处理逻辑
      }
    }, 
  }
}
</script>


<style lang="scss" scoped>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  overflow-x: hidden;
}
:root { // 全局变量
  --width: 0;
  --height: 0;
}
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.2em;
  gap: 10px;
}
</style>
